<template>
	<el-select v-bind="$attrs" v-on="$listeners" class="cbs-select-number">
		<el-option v-for="item in numberOptions" :key="item" :label="item" :value="item" />
	</el-select>
</template>

<script>
export default {
	inheritAttrs: false,
	name: "CbsSelectNumber",
	props: {
        maxNumber: {
            type: Number,
            default: 31
        }
	},
	data() {
		return {
			numberOptions: [...Array(this.maxNumber).keys()].map(i => i + 1)
		};
	}
};
</script>

<style></style>
